export enum EventType {
    Convention = 0,
    Congress = 1,
    DiningDrinks = 2,
    Museum = 3,
    Music = 4,
    OpenHouse = 5,
    Travel = 6,
    SeminarTraining = 7,
    SportsGames = 8,
    Theater = 9,
    Webinar = 10,
    Showroom = 11,
    Hybrid = 12
}
